import React, { useEffect, useState } from 'react'
import { useAuth } from 'react-oidc-context'

export const DeviceDeactivatedScreen = () => {
  const auth = useAuth()
  const [redirecting, setRedirecting] = useState(false)

  useEffect(() => {
    auth.removeUser().catch(error => {
      window.appInsights?.trackException({ exception: error as Error })
    })
  }, [])

  const goToActivation = async () => {
    setRedirecting(true)
    try {
      await auth.signinRedirect()
    } catch {
      setRedirecting(false)
    }
  }

  return (
    <div className="app__error">
      <div className="app__error__text">
        <h2>Device Deactivated</h2>
        <p>
          This device has been deactivated. You will need to enter a new activation code and PIN.
        </p>
        <button className="button" onClick={goToActivation} disabled={redirecting}>
          Enter Activation Code
        </button>
      </div>
    </div>
  )
}
